<div id="coAppInviteOuterDiv" class="co-app-invite-sent" *transloco="let t">
	<op-masthead [title]="t('CO_APP.INVITE_SENT.heading')"></op-masthead>

	<op-content-container class="content">
		<div class="content-container">
			<div class="co-app-info">
				<div class="op-header-4">{{ coAppDetails.firstName }} {{ coAppDetails.lastName }}</div>
				<div class="contact-info op-light-black">
					<div class="phone">
						<mat-icon svgIcon="op-phone-1"></mat-icon>
						<span id="coAppPhoneNumber"> {{ coAppDetails.phoneNumber }} </span>
					</div>

					<div class="email">
						<mat-icon svgIcon="op-email-1"></mat-icon>
						<span id="coAppEmailAddress"> {{ coAppDetails.emailAddress }} </span>
					</div>
				</div>
				<div class="steps op-light-black">
					{{ t('CO_APP.INVITE_SENT.textWithInstructions', { coApplicant: coAppDetails.firstName }) }}
				</div>
			</div>

			<section class="content-section" id="reach-out-container">
				<header class="section-header">
					<label class="op-header-4-font">{{
						t('CO_APP.INVITE_SENT.reachOut', { coApplicant: coAppDetails.firstName })
					}}</label>
				</header>

				<div class="op-body-1">
					{{ t('CO_APP.INVITE_SENT.callCoapp', { coApplicant: coAppDetails.firstName }) }}
				</div>

				<div class="op-mt-16">
					<button
						class="op-full-width"
						mat-flat-button
						color="secondary"
						name="callCoApplicant"
						id="call-co-applicant"
						[opTagClick]="'call-co-applicant'"
						(click)="callCoApp()"
						type="button"
					>
						{{ t('CO_APP.INVITE_SENT.callNow') }}
					</button>
				</div>
			</section>

			<div class="need-help">
				<div>{{ t('CO_APP.INVITE_SENT.needHelp') }}</div>
				<div [innerHTML]="t('CO_APP.INVITE_SENT.callUs')"></div>
			</div>

			<div>
				<op-co-app-common-questions
					id="op-co-app-common-questions"
					[questionType]="questionTypeEnum.INVITE_SENT"
				></op-co-app-common-questions>
			</div>
		</div>
	</op-content-container>
</div>
